import { render, staticRenderFns } from "./AcademicData.vue?vue&type=template&id=9eb8f210&scoped=true"
import script from "./AcademicData.vue?vue&type=script&lang=js"
export * from "./AcademicData.vue?vue&type=script&lang=js"
import style0 from "./AcademicData.vue?vue&type=style&index=0&id=9eb8f210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb8f210",
  null
  
)

export default component.exports